import { Component, ElementRef, NgZone, OnDestroy, OnInit, inject, viewChild } from '@angular/core';

/** Reaches 90% after this many seconds, then keeps creeping towards 100% */
const SECONDS_TO_90_PERCENT = 2;
const TIME_CONSTANT = SECONDS_TO_90_PERCENT / Math.log(10);

/**
 * Indeterminate-duration loading bar that fills with an exponential decay:
 * progress = 1 - e^(-t / tau). Meant to live under a button while the
 * proof of work is being solved; the parent removes it once done.
 */
@Component({
  selector: 'app-pow-progress',
  template: `<div class="track"><div class="fill" #fill></div></div>`,
  styles: `
    :host { display: block; width: 100%; }
    .track {
      height: 4px;
      border-radius: 2px;
      overflow: hidden;
      background: var(--mat-sys-surface-variant, rgba(128, 128, 128, 0.3));
    }
    .fill {
      height: 100%;
      width: 0;
      background: var(--mat-sys-primary, #6750a4);
    }
  `
})
export class PowProgressComponent implements OnInit, OnDestroy {
  private zone = inject(NgZone);
  private fill = viewChild.required<ElementRef<HTMLElement>>('fill');
  private frame = 0;

  ngOnInit() {
    const start = performance.now();
    // Animate outside Angular so every frame doesn't trigger change detection
    this.zone.runOutsideAngular(() => {
      const tick = (now: number) => {
        const progress = 1 - Math.exp(-((now - start) / 1000) / TIME_CONSTANT);
        this.fill().nativeElement.style.width = (progress * 100) + '%';
        this.frame = requestAnimationFrame(tick);
      };
      this.frame = requestAnimationFrame(tick);
    });
  }

  ngOnDestroy() {
    cancelAnimationFrame(this.frame);
  }
}
